import Modal from '@/components/Modal.vue';
import List from '@/components/list/List.vue';
import ListItem from '@/components/list/ListItem.vue';

export default {
    components: {
        Modal,
        List,
        ListItem,
    },
    data() {
        return {
            lang: 'de',
            remove: {
                open: false,
                id: null,
            },
        };
    },
    computed: {
        error() {
            return this.$store.state[this.$options.module].error;
        },
        list() {
            if (typeof this.compareTitles === 'function') {
                return this.$store.state[this.$options.module].list.sort(this.compareTitles);
            }
            return this.$store.state[this.$options.module].list;
        },
    },
    async created() {
        await this.$store.dispatch(`${ this.$options.module }/list`);
        if (typeof this.$route.query.m !== 'undefined' && this.$route.query.m) {
            const className = this.$route.query.m.startsWith('error_') ? 'error' : null;
            this.popOpen(this.$t(`general.errors.list.${ this.$route.query.m }`), className);
        }
    },
    methods: {
        getItemTitle(item) {
            return item.locales[this.lang] && typeof item.locales[this.lang].title !== 'undefined' ? item.locales[this.lang].title : '(empty)';
        },
        changeLang(language) {
            this.lang = language;
        },
        newItem() {
            this.$router.push({ name: `${ this.$options.module }.add` });
        },
        editItem(id) {
            this.$router.push({ name: `${ this.$options.module }.edit`, params: { id } });
        },
        removeItem(id) {
            this.remove.id = id;
            this.remove.open = true;
        },
        removeCancel() {
            this.remove.id = null;
            this.remove.open = false;
        },
        async removeConfirm() {
            const item = this.list.find((i) => i.id === this.remove.id);
            const title = this.getItemTitle(item);

            try {
                await this.$store.dispatch(`${ this.$options.module }/remove`, this.remove.id);
                if (this.error === null) {
                    this.popOpen(this.$t(`pages.${ this.$options.module }.list.pop_delete`, { title }));
                } else {
                    this.popOpen(this.$t(`general.errors.form.${ this.error }`), 'error');
                }
                await this.$store.dispatch(`${ this.$options.module }/list`);
            } catch (err) {
                if (process.env.NODE_ENV !== 'production') {
                    console.log(err);
                }
            }

            this.remove.id = null;
            this.remove.open = false;

            return null;
        },
        async activateItem(item) {
            item.state = 1;

            try {
                await this.$store.dispatch(`${ this.$options.module }/update`, item);
                if (this.error === null) {
                    this.popOpen(this.$t(`pages.${ this.$options.module }.list.pop_activate`, { title: this.getItemTitle(item) }));
                } else {
                    this.popOpen(this.$t(`general.errors.form.${ this.error }`), 'error');
                }
            } catch (err) {
                if (process.env.NODE_ENV !== 'production') {
                    console.log(err);
                }
            }
        },
        async deactivateItem(item) {
            item.state = 0;

            try {
                await this.$store.dispatch(`${ this.$options.module }/update`, item);
                if (this.error === null) {
                    this.popOpen(this.$t(`pages.${ this.$options.module }.list.pop_deactivate`, { title: this.getItemTitle(item) }));
                } else {
                    this.popOpen(this.$t(`general.errors.form.${ this.error }`), 'error');
                }
            } catch (err) {
                if (process.env.NODE_ENV !== 'production') {
                    console.log(err);
                }
            }
        },
    },
};
